<template>
  <MainLayout>
    <div class="col-md-12 column" style="height:calc(100% - 130px);">
      <div class="">
        <div class="col-md-12 column header">
          <div class="row">
            <div class="col-md-4 column">
            </div>
            <div v-if="csvOutFlag" class="col-md-4 column">
              <strong class="name-strong F3-M-27">[出力]ルートリスト</strong>
            </div>
            <div v-else class="col-md-4 column">
              <strong class="name-strong F3-M-27">ルートリスト</strong>
            </div>
            <div class="butStyle">
              <div></div>
              <div class="common-btn F2-M-19" @click="printMemberList()">一覧出力</div>
              <div class="common-btn F2-M-19" @click="memberRegistration()">+ 新規登録</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 column " style="display:flex;flex-direction: column; height:calc(96% - 30px);">
        <div class="table-container" style="margin-left:0px;margin-right:0px;height:calc(100% - 30px);">
          <div class="table-header" style="padding-right:10px;">
            <table>
              <thead>
                <tr class="theader F2-R-15 bgc9">
                  <td class="trborder route-id htd" v-show="csvOutFlag">
                    <input type="checkbox" v-model="allChecked" style="height:20px;width:20px;margin-left:0px;" @change ="allCheckEvent">
                  </td>
                  <td class="trborder route-id htd">ルートID</td>
                  <td class="trborder route-name htd">ルート名</td>
                  <td class="trborder route-startName htd">出発地</td>
                  <td class="trborder route-destinationName htd">終着地</td>
                  <td class="trborder route-distance htd">ルート距離</td>
                  <td class="trborder route-totalTime htd">所要時間</td>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-body scrollbar">
            <table class="table">
                <tr class="contenttr F3-R-16 bgc5h" v-for='route in routeList' v-bind:key="route.routeId" @click="clickRouteDetail(route)">
                  <td class="trborder route-id" v-show="csvOutFlag">
                      <input type="checkbox" v-model="route.isChecked" style="height:20px;width:20px;margin-left:0px;" @click="rowCheckBoxClickEvent(route)">
                   </td>
                  <td class="trborder bodytext route-id" style="text-align:center">{{route.displayRouteId}}</td>
                  <td class="trborder bodytext route-name overflow-fix">
                    <img src="../../assets/icon/transport_kind0.png" style="margin-right: 0; height: 32px;width:32px;" v-if="route.transportKind=='0'">
                    <img src="../../assets/icon/transport_kind1.png" style="margin-right: 0; height: 32px;width:32px;" v-if="route.transportKind=='1'">
                    <img src="../../assets/icon/app_use.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="route.routeType=='1'">
                    <img src="../../assets/icon/app_dontuse.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="route.routeType!='1'">
                    {{route.routeName}}</td>
                  <td class="trborder bodytext route-startName overflow-fix">{{ route.startStationAddressName }}</td>
                  <td class="trborder bodytext route-destinationName overflow-fix"> {{ route.endStationAddressName }}</td>
                  <td class="trborder bodytext2 route-distance">{{route.routeDistance}} km</td>
                  <td class="trborder bodytext route-totalTime" style="text-align: right;padding-right:20px;">
                    {{ route.routeTotalTime | timeFormatter }}
                  </td>
                </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--底部-->
      <div class="row clearfix" v-show="csvOutFlag" style="margin-top: 10px;">
          <div class="col-md-6 column">
              <button class="foot-button" style="float:right" @click="doPrint">出力</button>
          </div>
          <div class="col-md-6 column">
              <button class="foot-button" style="float:left" @click="cancelPrint">キャンセル</button>
          </div>
      </div>
      <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
  </MainLayout>
</template>

<script>
import MainLayout from '../layouts/mainLayout'
import dialog from '@/components/Dialog'
import axios from 'axios'
import { timeFormatter } from '../../filters/index.js'

export default {
  components: {
    MainLayout, 'v-dialog': dialog
  },
  data () {
    return {
      routeList: [],

      // 一览出力按钮按下否
      csvOutFlag: false,
      // 标题栏全选按钮按下否
      allChecked: false,

      // 确认框属性
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      // 是否弹出确认框
      showPrintDialog: false,
      // checkBox点击事件, 用来防止点击CheckBox后自动跳入RouteEvent画面
      rowCheckBoxClickFlag: false
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  mounted () {

  },
  methods: {
    // 获取数据
    loadData () {
      this.$axios.get('route/getRouteInfoList').then(response => {
        this.routeList = response.data.routeInfoList
        sessionStorage.setItem('routeInfoList', JSON.stringify(this.routeList))

        this.$axios.get('route/getAllStationData').then(res => {
          this.stationDataList = res.data.stationDataList
          // sessionStorage.setItem('stationDataList', JSON.stringify(this.stationDataList))

          let routeList = Object.assign([], this.routeList)
          for (let i of routeList) {
            // 开始Id
            let startStationId = i.routePassPointList[0].stationId
            // 终了Id
            let endStationId = i.routePassPointList[i.routePassPointList.length - 1].stationId
            for (const y of this.stationDataList) {
              // 找到开始点
              if (y.stationId === startStationId) {
                i.startStationAddress = y.address
                i.startStationAddressName = y.stationName
                i.startLng = y.stationLng
                i.startLat = y.stationLat
                i.startStaionName = y.stationName
              }
              // 找到终了点
              if (y.stationId === endStationId) {
                i.endStationAddress = y.address
                i.endStationAddressName = y.stationName
                i.endLng = y.stationLng
                i.endLat = y.stationLat
                i.endStaionName = y.stationName
              }
            }
          }
          this.routeList = routeList
        })
      }).catch(error => {
        console.log(error)
      })
    },

    // 跳转到详情页面
    clickRouteDetail (route) {
      // 如果点击的是CheckBox, 那么不跳转页面
      if (!this.rowCheckBoxClickFlag) {
        sessionStorage.setItem('clickRoute', JSON.stringify(route))
        this.$router.push({ path: '/RouteEvent' })
      } else {
        // 重置该状态,以便下次点击行可以跳转页面
        this.rowCheckBoxClickFlag = false
      }
    },
    // 新规登录
    memberRegistration () {
      this.$router.push({ name: 'NewRouteLogin' })
    },
    printMemberList () {
      // 显示checkBox和底部按钮
      this.csvOutFlag = true
    },

    // 出力
    doPrint () {
      // 打印列表
      let printList = []
      for (let i = 0; i < this.routeList.length; i++) {
        if (this.routeList[i].isChecked) {
          this.routeList[i].routeTotalTimeStr = timeFormatter(this.routeList[i].routeTotalTime)
          printList.push(this.routeList[i])
        }
      }

      // 根据是否勾选数据,弹出不同的确认框
      if (printList.length === 0) {
        let dialogPrintOption = {
          showNo: false,
          text: 'ルートを選択してください。',
          confirmButtonText: 'OK'
        }
        this.dialogPrintOption = dialogPrintOption

        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          this.showPrintDialog = false
        })
          .catch(() => {
            this.showPrintDialog = false
          })
      } else {
        let dialogPrintOption = {
          showNo: true,
          text: 'データをダウンロードします。<br/>よろしいですか？',
          cancelButtonText: 'キャンセル',
          confirmButtonText: '実行'
        }
        this.dialogPrintOption = dialogPrintOption

        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          axios({
            method: 'post',
            url: 'route/downloadCsvFile',
            data: printList,
            responseType: 'blob'
          }).then(response => {
            let url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'ルートリスト.csv')
            document.body.appendChild(link)
            link.click()
          }).catch((error) => {
            console.log(error)
            let dialogPrintOption = {
            showNo: false,
            text: '予期せぬエラーが発生しました。',            
            confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })          
          })

          this.showPrintDialog = false
        }).catch(() => {
          this.showPrintDialog = false
        })
      }
    },
    // 取消
    cancelPrint () {
      // 不显示CheckBox
      this.csvOutFlag = false

      // 恢复到全部不勾选状态
      this.allChecked = false
      this.allCheckEvent()
    },
    // 全选
    allCheckEvent () {
      for (let i = 0; i < this.routeList.length; i++) {
        if (this.allChecked) {
          this.routeList[i].isChecked = true
        } else {
          this.routeList[i].isChecked = false
        }
      }
    },
    // 行勾选或反勾选事件
    rowCheckBoxClickEvent (route) {
      this.rowCheckBoxClickFlag = true
    }
  }
  // beforeRouteLeave (to, from, next) {
  //   // 路由离开前的操作
  //   next()
  // }
}
</script>

<style lang="scss" scoped>
.butStyle {
  display: flex;
  & > div {
    flex: 1;
    margin-right: 5px;
  }
}
.header {
  padding-top: 18px;
  padding-bottom: 18px;
}

.name-strong {
  font-size: 30px;
}
tr:hover{
  // background-color: rgb(238, 238, 238)
  background-color: rgb(139, 139, 139);
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-left: 5px;
  margin-right: 5px;
  table-layout: fixed;
}

tbody .trborder {
  line-height: 30px;
  height: 30px;
  color: black;
  background-color:  rgb(230, 230, 230)
}

.bodytext {
  padding-left: 15px;
  text-align: left;
}
.bodytext2 {
  text-align: right;
  padding-right: 20px;
}
.table>tbody>tr>td {
  padding-top: 13px;
}

.htd {
  padding: 5px;
}

.route-id {
  width: 6%;
}

.route-name {
  width: 34%;
}

.route-startName {
  width: 16%;
}

.route-destinationName {
  width: 16%;
}

.route-distance {
  width: 12%;
}

.route-totalTime {
  width: 12%;
}
 @media screen and (max-device-width: 1480px) {
   .bodytext {
     font-size: 14px;
   }
 }
</style>



// WEBPACK FOOTER //
// src/router/views/RouteList.vue